module.exports = __webpack_public_path__ + "img/impactoF2.e4e2963a.png";